export enum CIORelationshipAction {
	ADD = 'add_relationships',
	REMOVE = 'delete_relationships'
}
